import { Controller } from "@hotwired/stimulus";

// Generic Fomantic modal trigger.
// Use on a link/button whose href (or data-modal-target value) is the modal's
// CSS selector — e.g. `data-action="click->modal#open" href="#my-modal"`.
export default class extends Controller {
  static values = { target: String };

  open(event) {
    event.preventDefault();
    const selector = this.targetValue || this.element.getAttribute("href");
    if (!selector) return;
    window.$(selector).modal("show");
  }
}
